import type React from "react";
import { SpaShell } from "../../../platform";
import type { BmiAppSettings } from "../types";

export function BmiShell({ children, settings }: { children: React.ReactNode; settings: BmiAppSettings }) {
  return (
    <SpaShell contentClassName="bmi-content" navigation={settings} themeClassName="bmi-app">
      {children}
    </SpaShell>
  );
}
